export default __webpack_public_path__ + "static/image 61-c92eee0e791aea089d533f85ac3aaf5f.png";